<template>
  <div v-if="menuItem.isStatic" class="sidemenu-mask-dropdown-list" :open="'open'" :level="nextLevel" :ref="menuItem.id" style="padding-left: 0rem !important">
    <div v-for="report in menuItemReportsByNameDesc" :key="report.id">
      <spin-loader v-if="isLoading && selectedReportId === report.id" />
      <div
        v-else
        class="sidemenu-mask-item"
        :type="report.typeCode"
        @click.stop="
          () => {
            isLoading = true
            selectedReportId = report.id
            getReport(report).then(() => {
              isLoading = false
            })
          }
        "
      >
        <div class="tooltip-hover" :open="undefined" :title="report.displayName">
          <i class="fas fa-file item"></i>
          {{ report.displayName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, inject } from 'vue'
import _ from 'underscore'

const props = defineProps({
  reports: Object,
  menuItem: Object,
  level: Number,
})

const menuItemReports = ref([])
const isLoading = ref(false)
const selectedReportId = ref(null)

watch(
  () => props.reports,
  (reports) => {
    menuItemReports.value = reports
  }
)

const nextLevel = computed(() => {
  return props.level + 1
})

const joinedmenuItemReportsFromAllYears = computed(() => {
  let reports = []

  if (menuItemReports.value === null) {
    return []
  }

  Object.keys(props.reports).forEach((year) => {
    props.reports[year].forEach((report) => {
      reports.push(report)
    })
  })

  return reports
})

const menuItemReportsByNameDesc = computed(() => {
  const reportKeys = Object.keys(props.reports)

  if (reportKeys !== null && reportKeys.length > 0) {
    let nameParsedmenuItemReports = []
    joinedmenuItemReportsFromAllYears.value.forEach((report) => {
      nameParsedmenuItemReports.push({
        ...report,
        name: report.displayName,
      })
    })

    return _.sortBy(nameParsedmenuItemReports, 'name').reverse()
  } else {
    return []
  }
})

const getReport = inject('getReport')
</script>
